module.exports = __webpack_public_path__ + "img/warning-icon.29a21fb5.svg";